import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for EditableValue
export const EditableValue = createSlice({
  name: "EditableValue",
  initialState: {
    isLoading: false,
    isSuccess: false,
    api_completed: false,
    isFirst: true,
    data: [],
  },
  reducers: {
    edit_EditableValue: (state, action) => {
      state.data = action.payload;
    },
    success_api_call_EditableValue: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
      state.isFirst = true;
    },
    failure_api_call_EditableValue: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.api_completed = true;
      state.isSuccess = false;
    },
    EditableValue_is_success: (state) => {
      state.isSuccess = false;
    },
    EditableValue_complete_api: (state) => {
      state.api_completed = false;
    },
  },
});
export default EditableValue.reducer;
export const {
  edit_EditableValue,
  success_api_call_EditableValue,
  EditableValue_complete_api,
  failure_api_call_EditableValue,
  EditableValue_is_success,
} = EditableValue.actions;
